import types from '../constants';

const emptyData = {
  uid: '',
  sid: '',
  firstName: '',
  lastName: '',
  email: '',
  token: '',
  refreshToken: '',
  expire: '',
  type: '',
  isLoading: false
};

const fakeData = {
  username: '',
  email: '',
  birthdate: '',
  gender: '',
  phoneNumber: '',
  photo: '',
  location: ''
};

const initialState = Object.assign(emptyData, fakeData);
export default function runtime(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };
    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case types.UPDATE_SETTING_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_SETTING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        setting: action.payload
      };
    case types.UPDATE_SETTING_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case types.FETCH_PROFILE_USER:
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };

    case types.SET_USER_VARIABLE:
      return {
        ...initialState,
        ...state,
        [action.payload.name]: action.payload.value
      };
    default:
      return { ...initialState, ...state };
  }
}
